import { ExpandableActionSidebar } from "./ExpandableActionSidebar";
import { LeftSidebar } from "./LeftSidebar";
import { ThinSidebar } from "./ThinSidebar";

export const ExpandableLeftSidebar = Object.assign(LeftSidebar, {
  ThinSidebar,
  ExpandableActionSidebar,
});
